import React from "react";

const HeaderBodySeparator = () => {
  return <div className="header-body-separator" />;
};

export default HeaderBodySeparator;
